import axios from "axios";
import {message} from 'antd';
const API_URL = process.env.REACT_APP_BASE_URL;

// const dispatch = useDispatch();
const register = (Membername,BusinessName,BusinessMobile,email,password) => {

  return axios.post(API_URL + "client/create",JSON.stringify({
    clientName: BusinessName,
    clientPassword: password,
    contactPerson: Membername,
    merchantNumber: BusinessMobile,
    clientEmail: email,
  }),{
    headers: {
        'Content-Type': 'application/json'
    }})
     .then((response) => {
      console.log(response);
      message.success('Registration successfull, please click sign in to log in')
      return response.data;
  });
};

const Login = ( username,password ) => {
  //console.log(username,password);
  // const dispatch = useDispatch();
  return axios
    .post(API_URL + "client/login",JSON.stringify({ "username":username, "password":password }),{
        headers: {
            'Content-Type': 'application/json'
        }
        })
       .then((response) => {
        console.log(response);
      if (response.data.ClientApikey) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
};
const logout = () => {
  localStorage.removeItem("user");
};

const authService = {
  register,
  Login,
  logout,
};
export default authService;